import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, Optional, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { RouteAction } from '@core/action/action';
import { ProdutoElement } from '@core/models/produto';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Subscription } from 'rxjs';
import { BaseSharedService } from '../base-shared/base-shared.service';
import { Field } from '@core/models/field';
import { AcaoBtnTabelaEnum } from '../table-cadastro/table-cadastro.enum';
import { converterItensVaziosEmNull, separarNumeroCena, separarNumeroCenanNewVersion } from '@shared/util/util';
import dayjs from 'dayjs';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnDestroy {

  @ViewChild('tabela', { static: false }) nzTableComponent?: NzTableComponent<any>;
  protected subscription: Subscription = new Subscription();

  productActual!: ProdutoElement;
  fields: Field[] = [];
  lists: any[] = [];
  acaoBtnEnum = AcaoBtnTabelaEnum;
  protected model: any;
  protected ultimaAlteracao!: string;
  protected usuarioAlteracao!: string;

  pageIndex = 0;
  pageSize = 10;
  pageSizeOptions = [10, 25, 50, 100]
  totalElements!: number;
  filtro: any;
  formulario!: FormGroup;
  voltarCena: boolean = false;
  dataSet: any;
  loadingTabela: boolean = false;
  isShowTable: boolean = false;
  total: number = 0;

  idParams!: number;
  acao!: RouteAction;
  acaoEnum = RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  actionActual: RouteAction = RouteAction.Padrao;

  fileList: CustomNzUploadFile[] = [];
  imagensList: CustomNzUploadFile[] = [];
  archiveUpload: any;
  previewVisible: boolean = false;
  previewImage: any;
  arquivo: any;

  listOfControl: Array<{ id: number; controlInstance: string }> = [];

  acaoBtnTabelaEnum = AcaoBtnTabelaEnum;

  anosLista: any[] = [];
  maskPlacasVeiculos = [/[A-Z]/, /[A-Z]/, /[A-Z]/, /[0-9]/, /[A-Z0-9]/, /[0-9]/, /[0-9]/];
  textoInformativoPlaca = 'Utilize o formato antigo "ABC-1234" ou Mercosul "ABC1D23".';
  mascaraPlaca = '^[A-Z]{3}(?:-[0-9]{4}|-[0-9][A-Z][0-9]{2})$';

  modalCenaCadastroRef!: NzModalService;

  protected fb = this.baseSharedService.getFormBuilder();
  protected router = this.baseSharedService.getRouter();
  protected route = this.baseSharedService.getRoute();
  protected dialogService = this.baseSharedService.getDialogService();
  protected formService = this.baseSharedService.getFormService();
  protected uploadService = this.baseSharedService.getUploadService();
  protected sanitizer = this.baseSharedService.getSanitizer();
  public location = this.baseSharedService.getLocation();
  protected notificationService = this.baseSharedService.getNotificationService();
  protected appSharedDataService = this.baseSharedService.getAppSharedDataService();
  protected authenticationService = this.baseSharedService.getAuthenticationService();
  protected uploadSharedDataService = this.baseSharedService.getUploadSharedDataService();

  @Optional() protected modalService!: NzModalService;
  
  constructor(
    protected baseSharedService: BaseSharedService,
  ) { }

  carregarProduto() {
    this.productActual = this.authenticationService?.currentUserValue?.produto;
  }

  consultarList(form?: FormGroup, service?: any) {
    this.filtro = (form) ? form.value : this.createNullJSON(this.fields);
    this.submitList(this.filtro, service);
  }

  submitList(form?: FormGroup, service?: any) {
    this.nzTableComponent?.cdkVirtualScrollViewport?.scrollToIndex(0);
    this.filtro = form;

    this.salvarFiltroComUrl(this.filtro);
    // const isEquipe = this.router.url;
    // sessionStorage.setItem('filtro', JSON.stringify(this.filtro));

    if (service) {
      this.searchListlNewVersion(service, true);
    }
  }

  salvarFiltroComUrl(filtroData: any): void {
    const urlBase = this.router.url.split('?')[0].split('/editar')[0]; // tira params ou editar
    const objParaSalvar = {
      url: urlBase,
      data: filtroData
    };
  
    sessionStorage.setItem('filtro', JSON.stringify(objParaSalvar));
  }

  searchListlNewVersion(service: any, reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }
  
    this.loadingTabela = true;
    this.isShowTable = false;
  
    const objEnvio = { ...this.filtro };
  
    if (objEnvio.numeroCena) {
      const { numCena, complementoCena } = separarNumeroCenanNewVersion(objEnvio.numeroCena);
  
      objEnvio.numeroCena = numCena || null;
      objEnvio.complementoCena = complementoCena || null; 
    }
  
    if (objEnvio.grupo !== undefined && objEnvio.usuario !== undefined) {
      Object.assign(objEnvio, converterItensVaziosEmNull(objEnvio));
    }
  
    service.consultar(objEnvio, this.pageIndex, this.pageSize).subscribe({
      next: (data: any) => {
        this.dataSet = data?.content ? data : (data.content = data);
        this.nzTableComponent?.cdkVirtualScrollViewport?.checkViewportSize();
        this.isShowTable = true;
  
      },
      complete: () => (this.loadingTabela = false),
      error: () => (this.loadingTabela = false),
    });
  }

  searchList(service: any, reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingTabela = true;
    this.isShowTable = false;

    let objEnvio = this.filtro;

    if(objEnvio.numeroCena) {
      const cena = separarNumeroCena(objEnvio.numeroCena);
      objEnvio.numeroCena = cena.numCena;
      objEnvio.complementoCena = cena.complementoCena;
    }

    if (this.filtro?.grupo !== undefined && this.filtro?.usuario !== undefined) {
      objEnvio = converterItensVaziosEmNull(this.filtro);
    }

    service.consultar(objEnvio, this.pageIndex, this.pageSize).subscribe({
      next: (data: any) => {
        this.dataSet = data?.content ? data : data.content = data;
        this.nzTableComponent?.cdkVirtualScrollViewport?.checkViewportSize();
        this.isShowTable = true;

      },
      complete: () => this.loadingTabela = false,
      error: () => this.loadingTabela = false
    });
  }

  resetList(form: FormGroup) {
    form.reset();
    this.dataSet = [];
    this.isShowTable = false;
  }

  inactiveItemList(service: any, item: any, nameItem: string, description: any) {
    this.dialogService.confirm(`Tem certeza de que deseja desativar o ${nameItem}: ${description} ?`, () => {
      service.desativar(item?.id).subscribe(() => {
        this.appSharedDataService.setResetar(true);
        this.notificationService.success('Sucesso!', `${nameItem} desativado com sucesso.`);
      })
    })
  }

  activeItemList(service: any, item: any, nameItem: string, description?: any) {
    this.dialogService.confirm(`Tem certeza de que deseja ativar ${nameItem}: ${description} ?`, () => {
      service.ativar(item?.id).subscribe(() => {
        this.appSharedDataService.setResetar(true);
        this.notificationService.success('Sucesso!', `${nameItem} ativado com sucesso.`);
      })
    })
  }

  mudarStatusItemList(service: any, item: any, action: boolean, nameItem: string, description?: any) {
    const objEnvio = {
      ativo: action
    };

    const textoAcao = action ? 'ativar' : 'inativar';
    this.dialogService.confirm(`Tem certeza de que deseja ${textoAcao} ${nameItem}: ${description} ?`, () => {
      service.mudarStatus(item?.id, objEnvio).subscribe(() => {
        const texto = action ? 'ativado' : 'inativado';
        this.notificationService.success('Sucesso!', `${nameItem} ${texto} com sucesso.`);
        this.appSharedDataService.setResetar(true);
      })
    })
  }

  deleteItem(service: any, item: any, nameItem: string) {
    this.dialogService.confirm(`Tem certeza de que deseja remover ${nameItem}?`, () => {
      service.deletar(item?.id).subscribe(
        () => {
          this.appSharedDataService.setResetar(true);
          this.notificationService.success('Sucesso!', `${nameItem} removido com sucesso.`);
        },
        // (error: HttpErrorResponse) => {
        //   let errorMessage = '';
        //   if (error?.error?.message) {
        //     errorMessage = error.error.message;
        //   } else if (error?.error?.mensagem) {
        //     errorMessage = error.error.mensagem;
        //   } else if (typeof error === 'string') {
        //     errorMessage = error;
        //   } else if (error?.error) {
        //     errorMessage = JSON.stringify(error.error);
        //   }
        //   if (errorMessage) {
        //     this.notificationService.error('Erro!', errorMessage);
        //   }
        // }
      );
    });
  }


  searchDataItem(service: any, form: FormGroup, itemId?: number, telefoneFormArray?: FormArray, image?: boolean) {

    this.imagensList = [];
    this.uploadSharedDataService.setImagensList(this.imagensList);

    if (this.editar || this.visualizar || itemId) {
      if(itemId || this.idParams) {
        const idParams = itemId || this.idParams;
        sessionStorage.setItem('idParamsEditarRoupa', idParams.toString());
      }

      service.consultarPorId(itemId ?? this.idParams).subscribe((res: any) => {
        this.model = res;

        if (telefoneFormArray) {
          this.converterTelefone(res?.telefones, telefoneFormArray);

          if (res.telefones.length == 0) {
            this.adicionarTelefone(telefoneFormArray)
          }
        }
        if (image) {
          this.convertImage(res);
        }

        form.patchValue(res);

        this.ultimaAlteracao = res.dataAlteracao ?? undefined;
        this.usuarioAlteracao = res.userLogin ?? undefined;
      });

      if (this.visualizar) {
        form.disable();
      }
    }
  }

  searchDataItemResponse(service: any, form: FormGroup, itemId?: number): Observable<any> {
    return new Observable((observer) => {
      if (this.acao == RouteAction.Editar || this.acao == RouteAction.Visualizar) {
        service.consultarPorId(itemId ?? this.idParams).subscribe((res: any) => {
          form.patchValue(res);
          observer.next(res);
          observer.complete();
        });

        (this.visualizar) || form.disable();
      }
    });
  }

  searchDataItemResponseDynamic(service: any, itemId?: number): Observable<any> {
    return new Observable((observer) => {
      if (this.acao == RouteAction.Editar || this.acao == RouteAction.Visualizar) {
        service.consultarPorId(itemId ?? this.idParams).subscribe((res: any) => {
          // form.patchValue(res);
          observer.next(res);
          observer.complete();
        });

        // (this.visualizar) || form.disable();
      }
    });
  }

  submitForm(form: FormGroup, elementForm: ElementRef, service: any, objSubmit: any, nameItem: string, rotaBack?: string, itemId?: number) {
    const messages = this.formService.getValidationsMessages(form, elementForm);
    this.formService.validateAllFormFields(form);

    if (messages.length) {
      this.notificationService.warn('Os seguintes campos abaixo devem ser preenchidos corretamente:', this.formService.createValidationList(messages));
      return;
    }

    objSubmit = converterItensVaziosEmNull(objSubmit);

    if (form.valid) {
      switch (this.acao) {
        case RouteAction.Inserir:
          this.submitRegisterForm(service, objSubmit, nameItem, rotaBack);
          break;
        case RouteAction.Editar:
          this.submitEditForm(service, objSubmit, nameItem, rotaBack, itemId ?? this.idParams);
          break;
      }
    } else {
      this.notificationService.error('Atenção', 'Existem campos obrigatórios a serem preenchidos.');
    }
  }

  submitFormModal(form: FormGroup, elementForm: ElementRef, service: any, objSubmit: any, nameItem: string) {
    const messages = this.formService.getValidationsMessages(form, elementForm);
    this.formService.validateAllFormFields(form);

    if (messages.length) {
      this.notificationService.warn('Os seguintes campos abaixo devem ser preenchidos corretamente:', this.formService.createValidationList(messages));
      return;
    }

    objSubmit = converterItensVaziosEmNull(objSubmit);
    console.log(this.acao);
    console.log(this.idParams);

    if(form.valid) {
      if(this.idParams === undefined) {
        this.submitRegisterForm(service, objSubmit, nameItem, undefined, true);
      } else {
        this.submitEditForm(service, objSubmit, nameItem, undefined, this.idParams, true);
      }
    } else {
      this.notificationService.error('Atenção', 'Existem campos obrigatórios a serem preenchidos.');
    }
    
  }

  submitFormValid(service: any, objSubmit: any, nameItem: string, rotaBack?: string, itemId?: number) {
    switch (this.acao) {
      case RouteAction.Inserir:
        this.submitRegisterForm(service, objSubmit, nameItem, rotaBack);
        break;
      case RouteAction.Editar:
        this.submitEditForm(service, objSubmit, nameItem, rotaBack, itemId ?? this.idParams);
        break;
    }
  }

  submitRegisterForm(service: any, objSubmit: any, nameItem: string, rotaBack?: string, modal?: boolean) {
    const rota = this.formatarString(nameItem);


    const paginasQueNaoVoltamParaLista = ['Cena', 'Roteiro'];
    const voltarPagina = !paginasQueNaoVoltamParaLista.includes(nameItem);


    console.log(voltarPagina)

    const sub = service.cadastrar(objSubmit).subscribe({
      next: (data: any) => {
        (nameItem == 'produto') || this.appSharedDataService.setAtualizarImagemProduto(true);
        this.notificationService.success('Sucesso!', `${nameItem} cadastrado com sucesso.`);

        const paginasQueNaoVoltamParaLista = ['Cena', 'Roteiro'];
        const voltarPagina = !paginasQueNaoVoltamParaLista.includes(nameItem);

        if(modal) {
          this.appSharedDataService.setCloseModal(true);
        }
        else if (data && objSubmit?.numeroCena) {
          if (data?.id) {
            this.idParams = data.id;
            this.router.navigate([`${rotaBack}/${this.idParams}`]);
          } else {
            if(voltarPagina) {
              this.router.navigate([rotaBack], { queryParams: { consultar: true } })
            }
          }
        } else {
          if(modal) {
            this.appSharedDataService.setCloseModal(true)
          } else {
            if(voltarPagina) {
              this.router.navigate([rotaBack], { queryParams: { consultar: true } })
            } else {
              if(nameItem == 'Roteiro') {
                this.router.navigate([`/cadastro/roteiro/editar/${data.id}`]);
              }
            }
          }
        }
      },
      error: (error: any) => {
        this.notificationService.error('Erro', `Erro ao cadastrar ${nameItem}. Por favor, tente novamente.`);
        console.error(`Erro ao cadastrar ${nameItem}:`, error);
      }
    });
    this.subscription.add(sub);
  }

  submitEditForm(service: any, objSubmit: any, nameItem: string, rotaBack?: string, itemId?: number, modal?: boolean) {
    objSubmit.id = itemId ?? this.idParams;
    const rota = this.formatarString(nameItem);

    service.editar(itemId ?? this.idParams, objSubmit).subscribe({
      next: (data: any) => {
        (nameItem == 'produto') || this.appSharedDataService.setAtualizarImagemProduto(true);
        this.notificationService.success('Sucesso!', `${nameItem} editado com sucesso.`);
        
        const paginasQueNaoVoltamParaLista = ['Cena', 'Roteiro'];
        const voltarPagina = !paginasQueNaoVoltamParaLista.includes(nameItem);

        if (modal)  {
          this.appSharedDataService.setCloseModal(true)
        } else {
          if(voltarPagina) {
            this.router.navigate([rotaBack], { queryParams: { consultar: true } })
          }
        }
      },
      error: (error: any) => {
        this.notificationService.error('Erro', `Erro ao editar ${nameItem}. Por favor, tente novamente.`);
        console.error(`Erro ao editar ${nameItem}:`, error);
      }
    });
  }

  adicionarTelefone(form: FormArray, e?: MouseEvent): void {
    const telefoneGroup = this.fb.group({
      telefone: ['']
    });

    if (this.visualizar) {
      telefoneGroup.disable({ emitEvent: false });
    }

    form.push(telefoneGroup);
  }

  removerTelefone(form: FormArray, index: number) {
    form.removeAt(index);
  }

  handlePreview(file: any) {
    this.previewVisible = false;

    if (file.id) {
      this.uploadService.consultarPorId(file.id).subscribe({
        next: (val: any) => {
          val.subscribe((base64String: string) => {
            file.url = base64String;
            this.previewVisible = true;
          });
        },
        error: (error: any) => {
          this.previewVisible = false;
        }
      });
    }
  };

  getSanitizedImageSrc(file: any) {
    return (file.url) ? this.sanitizer.bypassSecurityTrustUrl(file.url) : null;
  }

  beforeUpload = (file: any): boolean => {
    // let allowedExtensions: string[] = ['.jpg', '.jpeg', '.png'];

    // const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

    // if (!allowedExtensions.includes(fileExtension)) {
    //   this.notificationService.warn('Atenção!', 'Tipo de arquivo não permitido. Por favor, selecione um arquivo do tipo imagem.');
    //   return false;
    // }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e: any) => {

      const arquivo: any = {};
      arquivo.base64Content = e.target?.result?.toString().split(',')[1];

      let imagem = new Image();
      imagem.src = e.target?.result;
      imagem.onload = () => {
        file.url = `data:text/html;base64,${arquivo.base64Content}`;
        file.arquivo = arquivo.base64Content;
        
        // this.fileList = [...this.fileList, file];
        // this.uploadSharedDataService.setFileList(this.fileList);

        this.uploadService.upload(file).subscribe((res: any) => {
          file.id = res.id;
          file.selected = false;
          file.originalFileName = file.name;
          file._novaImagemUpload = true;
          // this.fileList = [...this.fileList, file];
          this.imagensList = [...this.imagensList,  file]
          this.uploadSharedDataService.setImagensList(this.imagensList);
        })
      }
    }
    return false;
  };

  converterTelefone(telefones: any, form: FormArray) {
    for (const telefone of telefones) {
      form.push(this.fb.group({
        id: [telefone.id],
        telefone: [telefone.numeroTelefone]
      }));
    }

    if (this.visualizar) {
      form?.controls?.forEach(control => control.disable());
    }
  }

  popoverTelefone(item: any) {
    return (this.visualizar)
      ? 'Desabilitado'
      : item == 0 ? 'Adicionar novo número de telefone' : 'Remover número de telefone'
  }

  convertImage(item: any) {
    const imagens = item.imagens ?? item.imagem ?? [];
    const listaImagens = Array.isArray(imagens) ? imagens : [imagens];

    this.imagensList = listaImagens.map((imagem: any) => ({
      ...imagem,
      selected: imagem?.selected ?? false,
      _novaImagemUpload: false
    }));

    this.uploadSharedDataService.setImagensList(this.imagensList);
  }

  convertImageSubmit(imagens: any) {
    const imagensSemUndefined = imagens.filter((item: undefined) => item !== undefined);
    return Object.values(imagensSemUndefined).map((item: any) => {
      return { id: item.id, descricao: item?.descricao };
    });
  }

  formatarString(str: string): string {
    let novaStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    novaStr = novaStr.replace(/ç/g, 'c');
    novaStr = novaStr.replace(/[^\w\s]/gi, '');
    novaStr = novaStr.replace(/\s+/g, '_');
    novaStr = novaStr.toLowerCase();
    return novaStr;
  }

  removeImage(imagem: any): void {
    this.dialogService.confirm(`Tem certeza de que deseja remover a imagem: ${imagem.originalFileName} ?`, () => {
      const index = this.imagensList.indexOf(imagem);
      this.imagensList.splice(index, 1);
    })
  }

  createNullJSON(fields: any[]): any {
    const json: any = {};
    for (const field of fields) {
      if (field.name == 'ativo') {
        json[field.name] = true;
      } else {
        json[field.name] = null;
      }
    }
    return json;
  }

  resultFormEvent(form: FormGroup) {
    this.appSharedDataService.setBuscar(form);
  }

  resultResetFormEvent(res: boolean) {
    this.appSharedDataService.setResetar(res);
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }

    if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }
    else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }
    else {
      return a === b;
    }
  }

  getParams(service?: any) {
    this.route.params.subscribe((data) => {
      this.idParams = data['id'];
    })

    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;
    });

    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams['consultar']) {
        this.consultarList(undefined, service)
      }
      if (queryParams['cena']) {
        this.voltarCena = queryParams['cena'];
      }
    })
  }

  anoInicioFim(): void {
    const rangeAno = 60;
    const anoAtual = dayjs().year();
    const anoInicio = anoAtual - rangeAno;
    const anoFim = anoAtual + rangeAno;

    this.anosLista = [];
    for (let ano = anoInicio; ano <= anoFim; ano++) {
      this.anosLista.push(ano);
    }
  }

  maskPlaca(event: any, form: FormGroup, field: string): void {
    let value = event.target.value.toUpperCase();
    const length = value.length;

    if (length <= 3) {
      value = value.replace(/[^A-Z]/g, '');
      value = value.substring(0, 3);
    } else {
      value = value.replace(/[^A-Z0-9]/g, '');
      value = value.substring(0, 7);
      value = value.replace(/^([A-Z]{3})([0-9]{1})([A-Z0-9]{1})([0-9]{2})$/, '$1$2$3$4');
      if (value.length > 3) {
        value = value.substring(0, 3) + '-' + value.substring(3);
      }
    }
    event.target.value = value;
    form.get(field)?.setValue(value);
  }

  inserirImagens(objEnvioSubmit: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.uploadSharedDataService.imagensList$.subscribe(res => {
        objEnvioSubmit.imagens = res || [];

        // if (this.imagensList && this.imagensList.length > 0) {
        //   objEnvioSubmit.imagens = objEnvioSubmit.imagens.concat(this.imagensList);
        // }

        if (objEnvioSubmit.imagens && objEnvioSubmit.imagens.length > 0) {
          objEnvioSubmit.imagens = this.convertImageSubmit(objEnvioSubmit.imagens);
        }

        resolve(objEnvioSubmit);
      }, err => reject(err));
    });
  }

  voltar(modal?: boolean, rota?: string) {
    (modal)
      ? this.appSharedDataService.setCloseModal(true)
      : rota ? this.router.navigate([rota]) : this.location.back();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  validarBooleano(str: any) {
    return str.toLowerCase() === 'true' || str.toLowerCase() === 'false';
  }

  tituloPagina(pagina: string) {
    switch (this.acao) {
      case RouteAction.Editar:
        return `Edição de ${pagina}`;
      case RouteAction.Visualizar:
        return `Visualização de ${pagina}`;
      default:
        return `Cadastro de ${pagina}`;
    }
  }
}

interface CustomNzUploadFile extends NzUploadFile {
  selected?: boolean;
  descricao?: string;
}
